// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Archive = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Archive = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Archive = _exports.Archive = function Archive(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1.875 3.125V5H18.125V3.125H1.875ZM1.25 1.25H18.75C19.4414 1.25 20 1.80859 20 2.5V5.625C20 6.31641 19.4414 6.875 18.75 6.875H1.25C0.558594 6.875 0 6.31641 0 5.625V2.5C0 1.80859 0.558594 1.25 1.25 1.25ZM6.25 9.6875C6.25 9.16797 6.66797 8.75 7.1875 8.75H12.8125C13.332 8.75 13.75 9.16797 13.75 9.6875C13.75 10.207 13.332 10.625 12.8125 10.625H7.1875C6.66797 10.625 6.25 10.207 6.25 9.6875ZM1.25 16.25V8.125H3.125V16.25C3.125 16.5938 3.40625 16.875 3.75 16.875H16.25C16.5938 16.875 16.875 16.5938 16.875 16.25V8.125H18.75V16.25C18.75 17.6289 17.6289 18.75 16.25 18.75H3.75C2.37109 18.75 1.25 17.6289 1.25 16.25Z",
      fill: "currentColor"
    }));
  };
});
